module.exports = __webpack_public_path__ + "img/record-btn-fill.590689c7.svg";